// First-run admin setup, restyled onto the login-card chrome (00-login)
// when the legacy design-system classes were retired in phase 11. Only ever
// reached explicitly at /setup during a fresh deployment.

import { useState, type FormEvent } from 'react';
import { useIsMobile } from '../lib/useIsMobile';
import { api } from '../lib/api';

export default function Setup({ onDone }: { onDone: () => void }) {
  const isMobile = useIsMobile();
  const [setupToken, setSetupToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api('/api/auth/setup', {
        method: 'POST',
        json: { password, setup_token: setupToken },
      });
      onDone();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Setup failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-head">
          <div className="logo-mark">S</div>
          <div className="workspace-name">Sheahan OS</div>
          <span className="tag">First-run setup</span>
        </div>
        <form onSubmit={submit} className="login-body">
          <div className="login-title">Set the admin password.</div>
          <p style={{ fontSize: 12, color: 'var(--text-dim)', marginBottom: 14 }}>
            Enter the one-time token configured for this deployment. Setup locks after the first successful claim.
          </p>
          <div className="f-field">
            <span className="f-label">Deployment setup token</span>
            <input
              className="f-input mono"
              type="password"
              aria-label="Deployment setup token"
              value={setupToken}
              onChange={(e) => setSetupToken(e.target.value)}
              autoFocus
              autoComplete="off"
            />
          </div>
          <div className="f-field">
            <span className="f-label">Password (min 8 characters)</span>
            <input
              className="f-input"
              type="password"
              aria-label="Password (min 8 characters)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <div className="f-field">
            <span className="f-label">Confirm password</span>
            <input
              className="f-input"
              type="password"
              aria-label="Confirm password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          {error && (
            <p className="error-text" style={{ marginBottom: 14 }}>
              {error}
            </p>
          )}
          <button
            type="submit"
            className={isMobile ? "cbtn pri wide settings-login-submit" : "btn primary block"}
            disabled={busy || !setupToken || password.length < 8 || !confirm}
          >
            {busy ? 'Setting up…' : 'Create admin →'}
          </button>
        </form>
        <div className="login-foot">
          <span>os.sheahanstudios.com</span>
          <span>● Systems OK</span>
        </div>
      </div>
    </div>
  );
}
